import React from "react";
import { Card } from "primereact/card";
import { Chart } from "primereact/chart";
import { MonthlyAggregate } from "../../../../types/analytics";
import { CHART_COLORS, CHART_FONT, sharedChartOptions } from "./chartConfig";

interface RevenueTrendChartProps {
  monthly: MonthlyAggregate[];
}

const RevenueTrendChart: React.FC<RevenueTrendChartProps> = ({ monthly }) => {
  const chartData = {
    labels: monthly.map((m) => m.label),
    datasets: [
      {
        label: "Revenue",
        data: monthly.map((m) => m.revenue),
        borderColor: CHART_COLORS.primary,
        backgroundColor: CHART_COLORS.primaryLight,
        fill: true,
        tension: 0.3,
        pointBackgroundColor: CHART_COLORS.primary,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  const options = {
    ...sharedChartOptions,
    plugins: {
      ...sharedChartOptions.plugins,
      legend: { display: false },
      tooltip: {
        ...sharedChartOptions.plugins.tooltip,
        callbacks: {
          label: (ctx: any) => `${ctx.parsed.y.toFixed(2)} \u20AC`,
        },
      },
    },
    scales: {
      ...sharedChartOptions.scales,
      y: {
        ...sharedChartOptions.scales.y,
        ticks: {
          font: CHART_FONT,
          callback: (val: any) => `${val} \u20AC`,
        },
      },
    },
  };

  return (
    <Card className="shadow-2 h-full" title="Revenue Trend">
      <Chart type="line" data={chartData} options={options} style={{ width: "100%" }} />
    </Card>
  );
};

export default RevenueTrendChart;
